import React, { useRef, useState, useEffect } from "react";
import "./styles.scss";
import PropTypes from "prop-types";
import { Overlay, Popover } from "react-bootstrap";

function RollOver({
  delay,
  onMouseEnter,
  children,
  text,
  html,
  placement,
  type,
  className,
  htmlWrapperElement = "span",
  wrapperElementClassname = "target",
}) {
  const [showPopover, setShowPopover] = useState(false);
  const childNode = useRef(null);
  let setTimeoutConst = null;

  useEffect(() => {
    return () => {
      if (setTimeoutConst) {
        clearTimeout(setTimeoutConst);
      }
    };
  });

  const handleMouseEnter = () => {
    setTimeoutConst = setTimeout(() => {
      setShowPopover(true);
      onMouseEnter();
    }, delay);
  };

  const handleMouseLeave = () => {
    clearTimeout(setTimeoutConst);
    setShowPopover(false);
  };

  const Wrapper = htmlWrapperElement;
  const displayChild = React.Children.map(children, (child) =>
    React.cloneElement(<Wrapper className={wrapperElementClassname}>{child}</Wrapper>, {
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave,
      ref: (node) => {
        childNode.current = node;
        const { ref } = child;
        if (typeof ref === "function") {
          ref(node);
        }
      },
    })
  )[0];

  const classes = `custom-popover ${className ? className : ""} ${type === "follower" ? "follower" : "copylink"}`;
  return (
    <React.Fragment>
      {displayChild}
      <Overlay show={showPopover} placement={placement} target={childNode} shouldUpdatePosition>
        <Popover
          onMouseEnter={() => {
            setShowPopover(true);
          }}
          onMouseLeave={handleMouseLeave}
          className={classes}
          id="popover"
        >
          {html ? <div className="tooltip-message" dangerouslySetInnerHTML={{ __html: html }} /> : <div className="tooltip-message">{text}</div>}
        </Popover>
      </Overlay>
    </React.Fragment>
  );
}

RollOver.propTypes = {
  children: PropTypes.element.isRequired,
  delay: PropTypes.number,
  onMouseEnter: PropTypes.func,
  text: PropTypes.any,
  html: PropTypes.string,
  className: PropTypes.string,
  placement: PropTypes.string,
  type: PropTypes.string,
};

RollOver.defaultProps = {
  delay: 0,
  onMouseEnter: () => {},
};

export default RollOver;
